import Vue from 'vue'

const LSPlugin = {}

LSPlugin.install = function (Vue) {
  Vue.prototype.$ls = {
    get (item) {
      return window.localStorage ? localStorage.getItem(item) : null
    },
    set (item, lng) {
      if (window.localStorage) {
        localStorage.setItem(item, lng)
      }
    }
  }
}

Vue.use(LSPlugin)

export default LSPlugin
